module.exports = __webpack_public_path__ + "img/pizza-hero.d18502aa.png";